import { Spin } from "antd";
import type React from "react";

/**
 * @description Default page loading component
 */
export const PageLoading: React.FC = () => (
  <div className="flex justify-center items-center p-5">
    <Spin />
  </div>
);

/**
 * @description Component loading spinner
 */
export const ComponentLoading: React.FC = () => (
  <div className="flex justify-center items-center p-5">
    <Spin />
  </div>
);

/**
 * @description Non-blocking error fallback component
 * Shows a minimal error indicator that doesn't disrupt the page layout
 */
export const LazyLoadError: React.FC<{ error: Error; retry: () => void }> = ({ error }) => {
  console.warn("Lazy load component failed, rendering empty fallback:", error.message);

  // Return an empty div that doesn't disrupt the page layout
  // The error is logged but doesn't block the user interface
  return (
    <div
      className="min-h-0 opacity-0 pointer-events-none"
      title={`Component failed to load: ${error.message}`}
    >
      {/* Hidden error indicator - component failed to load but page continues to work */}
    </div>
  );
};
